var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 10.0013H16.2667C15.9026 10.0005 15.5481 10.1191 15.2577 10.3388C14.9672 10.5585 14.7567 10.8673 14.6584 11.218L12.7001 18.1846C12.6875 18.2279 12.6611 18.2659 12.6251 18.293C12.589 18.32 12.5452 18.3346 12.5001 18.3346C12.455 18.3346 12.4111 18.32 12.3751 18.293C12.339 18.2659 12.3127 18.2279 12.3001 18.1846L7.70008 1.81797C7.68746 1.77469 7.66114 1.73668 7.62508 1.70964C7.58902 1.68259 7.54516 1.66797 7.50008 1.66797C7.455 1.66797 7.41114 1.68259 7.37508 1.70964C7.33902 1.73668 7.3127 1.77469 7.30008 1.81797L5.34175 8.78464C5.2438 9.13393 5.03457 9.44173 4.7458 9.66131C4.45704 9.88089 4.10451 10.0003 3.74175 10.0013H1.66675",
    stroke: "#104145",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIcon);
export default __webpack_public_path__ + "static/media/chart-icon.f60fd3720305d3b4361312ec984cfa50.svg";
export { ForwardRef as ReactComponent };